import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {DD_PRIVACY_ALLOW} from '../../../util/datadog/privacy';

export const PanelDeleteMenuItem = ({onSelect}: {onSelect: () => void}) => {
  return (
    <DropdownMenu.Item
      className="hover:bg-red-300/[.48]"
      data-dd-action-name="Delete panel"
      data-dd-privacy={DD_PRIVACY_ALLOW}
      onSelect={onSelect}>
      <Icon name="delete" />
      Delete panel
    </DropdownMenu.Item>
  );
};
